import layout from '@/components/common/layout';
import cstudentList from '../views/cstudent/list';
import cstudentCreate from "../views/cstudent/create";

export default [
    {
        path: '/cstudent',
        component: layout,
        children: [
            {
                path: 'list',
                meta: {
                    metaInfo: {
                        title: "学员列表",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'cstudent_list',// 子选项
                    }
                },
                component: cstudentList,
            },
            {
                path: 'create',
                meta: {
                    metaInfo: {
                        title: "新增学员",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'cstudent_list',// 子选项
                    }
                },
                component: cstudentCreate,
            },
            {
                path: 'edit',
                meta: {
                    metaInfo: {
                        title: "编辑学员",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'cstudent_list',// 子选项
                    }
                },
                component: cstudentCreate,
            },
        ]
    },
];
